import api from '@pray/shared/utils/api';

/**
 * The catalogue of integration types and the fields each one asks for. When artistId is provided
 * the endpoint authorizes the caller on that artist, which is what lets a leader (editor or owner)
 * load it; without it (Pray staff) only a Studio admin is authorized.
 */
export const getAllLeadClientIntegrations = async ({
  artistId = null,
  offset = 0,
  limit = 0,
  sortColumn = '',
  sortDirection = 'asc',
  options = {},
} = {}) => {
  const params = {};

  if (artistId) params.artist_id = artistId;

  if (offset) params.offset = offset;

  if (limit) params.limit = limit;

  if (sortColumn) {
    params.sort_column = sortColumn;
    params.sort_direction = sortDirection;
  }

  const url = `/web/studio/lead-clients/integrations/options`;
  const response = await api.executeGetRequest(url, params, options);

  return response.data.data;
};
